import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {transition, trigger, useAnimation} from "@angular/animations";
import {createFlyToAnimation, getFlyToAnimationParams} from "../animations/fly-to";

@Component({
  selector: 'add-to-cart',
  standalone: false,
  template: `
    <button #addToBasketBtn type="button" class="btn btn-warning order-button"
            title="Add to cart" i18n-title
            (click)="click($event)">
            <span class="animated-cart"
                  [@addToCart]="getCartAnimation()"
                  (@addToCart.done)="animationDone($event)"><i class="fa fa-cart-plus"></i></span>
      <i id="cart-src{{ itemId }}" class="fa" [class.fa-plus-circle]="showLabel" [class.fa-plus]="!showLabel"></i><span *ngIf="showLabel">&nbsp;</span><span i18n *ngIf="showLabel">Add to cart</span>
    </button>
  `,
  animations: [
    trigger('addToCart', [
      transition('off => on',
        useAnimation(createFlyToAnimation({}))
      )
    ])
  ]
})

export class AddToCartButton {

  @Input() itemId: string;
  @Input() showLabel: boolean = true;
  @Output() clickAnimationDone = new EventEmitter<Event>();

  animationState: string = 'off';

  @ViewChild('addToBasketBtn') addToBasketRef: ElementRef;

  click($event) {
    this.animationState = 'off';
    this.animationState = 'on';
    $event.stopPropagation();
  }

  getCartAnimation() {
    return {
      value: this.animationState,
      params: getFlyToAnimationParams('cart-src' + this.itemId, 'checkout-button')
    }
  }

  animationDone($e) {
    this.animationState = 'off';
    // blur the button so it does not have focus, that looks ugly
    this.addToBasketRef.nativeElement.blur();
    if ($e.fromState == 'on' && $e.toState == 'off') {
      this.clickAnimationDone.emit($e);
    }
  }
}
